export default {
  path: 'notify_event',//路由不能用ding开头，线上部署nginx会反向代理ding前缀
  name: 'dingTalkNotifyEvent',
  component: () => import('@/pages/ding_talk/DingTalkEventList'),
  meta: { title: '钉钉通知' }
}
